<section class="lg-container settings-container">
  <form [formGroup]="settingsForm" class="flex-direction-column" layout>
    <cc-box>
      <div class="lg-container basic-settings-header" header box>
        <span translate>LEAD_GENERATION.BASIC_SETTINGS</span>

      </div>
      <div content box>


        <div class="lg-container settings-row">
          <div layout class="flex-between align-item-center">
            <label class="w-45">{{'LEAD_GENERATION.SETTINGS.ADD_WEBSIDE_FOR_CALLBACK_WIDGET' | translate}}</label>
              <div class="input-error">
                <input class="input light-grey-placeholder"
                       required
                       placeholder="https://"
                       formControlName="domainName">
                <cc-input-errors
                  [form]="settingsForm"
                  inputName="domainName"
                  [errors]="[{'required': 'LEAD_GENERATION.ENTER_VALID_ADDRESS'}, {'pattern': 'LEAD_GENERATION.ENTER_VALID_ADDRESS'}]">
                </cc-input-errors>
              </div>
            </div>
        </div>
        <div class="lg-container settings-row">
          <div class="">
            <label>
              {{'LEAD_GENERATION.SETTINGS.SUBDOMAINS_TITLE' | translate}}
              <span class="z-index-10 tooltip-wrap pos-rlt inline">
              <i class="material-icons t-minus-2 grey-text text-xs tooltip-hover-icon pos-rlt m-l-xs">help_outline</i>
              <span class="tooltip-cc box-border box-radius text-xs p-a-sm pos-abt min-w-200 _300 opacity-1" translate>LEAD_GENERATION.SETTINGS.SUBDOMAINS_TOOLTIP</span>
            </span>

            </label>
            <ui-switch formControlName="allowSubdomains" class="pull-right custom"></ui-switch>
          </div>
        </div>


        <div class="lg-container settings-row flex-between align-item-center device-container" layout>
          <label translate>LEAD_GENERATION.SETTINGS.DEVICES</label>
          <mat-select
            formControlName="displayOnDeviceType"
            class="w-45">
            <mat-option
              *ngFor="let item of deviceTypes"
              [value]="item" > {{'DEVICE.'+ item.toUpperCase() | translate}}
            </mat-option>
          </mat-select>
        </div>

        <div class="lg-container settings-row">
          <label translate>LEAD_GENERATION.SETTINGS.DISPLAY_WIDGET_ON_WEBSIDE</label>
          <ui-switch formControlName="active" class="pull-right custom"></ui-switch>
        </div>
      </div>
    </cc-box>

    <div class="lg-container"></div>

    <cc-display-condition-list
      [configuration]="config"
      [displayConditionsFormWrapper]="displayConditionsFormWrapper"
    ></cc-display-condition-list>

    <div class="lg-container"></div>

    <cc-lg-working-hours-list
      [configuration]="config"
      [workingHoursFormWrapper]="workingHoursFormWrapper"
      displayTitle="LEAD_GENERATION.SETTINGS.DISPLAY_WHEN"
    >

    </cc-lg-working-hours-list>

    <div class="button-wrapper">
      <button
        mat-raised-button
        (click)="onSubmit()"
        [disabled]="!isFormValid()"
        color="primary-full">
        {{creatingNewProject ? ('LEAD_GENERATION.SETTINGS.CREATE' | translate) : ('LEAD_GENERATION.SETTINGS.UPDATE' | translate) }}
      </button>
    </div>
  </form>
</section>
